export default
  reset: (context, payload) ->
    context.commit 'reset', payload
  # User
  updateUser: (context, payload) ->
    context.commit  'updateUser', payload
  showEdit: (context, payload) ->
    context.commit  'showEdit', payload
  newUserPhone: (context, payload) ->
    context.commit  'newUserPhone', payload
  userStart: (context, payload) ->
    context.commit 'userStart', payload
  # Kickout timer
  updateStateTimeLastActive: (context, payload) ->
    context.commit 'updateStateTimeLastActive', payload
  # Restaurant / Location
  updateRestaurant: (context, payload) ->
    context.commit  'updateRestaurant', payload
  updateIpHeader: (context, payload) ->
    context.commit  'updateIpHeader', payload
  updateSubdomain: (context, payload) ->
    context.commit  'updateSubdomain', payload
  updateTableNo: (context, payload) ->
    context.commit  'updateTableNo', payload
  updateTakeoutLocations: (context, payload) ->
    context.commit 'updateTakeoutLocations', payload
  updateDeliveryLocations: (context, payload) ->
    context.commit 'updateDeliveryLocations', payload
  updateLocations: (context, payload) ->
    context.commit 'updateLocations', payload
  updateClosedLocations: (context, payload) ->
    context.commit 'updateClosedLocations', payload
  updateLocation: (context, payload) ->
    context.commit 'updateLocation', payload
  updateDescFlag: (context, payload) ->
    context.commit 'updateDescFlag', payload
  updateMenuFlag: (context, payload) ->
    context.commit 'updateMenuFlag', payload
  # Order
  updateOrderHeader: (context, payload) ->
    context.commit 'updateOrderHeader', payload
  updateOrderMessage: (context, payload) ->
    context.commit 'updateOrderMessage', payload
  updateDiscount: (context, payload) ->
    context.commit 'updateDiscount', payload
  updateSubtotal: (context, payload) ->
    context.commit 'updateSubtotal', payload
  updateOrder: (context, payload) ->
    context.commit 'updateOrder', payload
  updateOrderDateTime: (context, payload) ->
    context.commit 'updateOrderDateTime', payload
  updateOrderTip: (context, payload) ->
    context.commit  'updateOrderTip', payload
  updateOrderComment: (context, payload) ->
    context.commit  'updateOrderComment', payload
  updateCustomerEmail: (context, payload) ->
    context.commit  'updateCustomerEmail', payload
  updateOrderUpdated: (context, payload) ->
    context.commit 'updateOrderUpdated', payload
  updateOrderPlace: (context, payload) ->
    context.commit  'updateOrderPlace', payload
  updateOrderStatus: (context, payload) ->
    context.commit  'updateOrderStatus', payload
  updateTipLevels: (context, payload) ->
    context.commit 'updateTipLevels', payload
  # OrderMenu
  updateOrderMenu: (context, payload) ->
    context.commit 'updateOrderMenu', payload
  updateOrderMenuDetails: (context, payload) ->
    context.commit 'updateOrderMenuDetails', payload
  menuLoaded: (context, payload) ->
    context.commit 'menuLoaded', payload
  # OrderItem
  addNewOrderItem: (context, payload) ->
    context.commit 'addNewOrderItem', payload
  updateOrderItem: (context, payload) ->
    context.commit 'updateOrderItem', payload
  updateNewOrderItem: (context, payload) ->
    context.commit 'updateNewOrderItem', payload
  updateExistingOrderItem: (context, payload) ->
    context.commit 'updateExistingOrderItem', payload
  # Coupons
  updateEditorCoupon: (context, payload) ->
    context.commit 'updateEditorCoupon', payload
  updateCouponApply: (context, payload) ->
    context.commit 'updateCouponApply', payload
  updateCoupons: (context, payload) ->
    context.commit 'updateCoupons', payload
  updateCouponItemIds: (context, payload) ->
    context.commit 'updateCouponItemIds', payload
  updateMywayIds: (context, payload) ->
    context.commit 'updateMywayIds', payload
  updateCouponsUpdated: (context, payload) ->
    context.commit 'updateCouponsUpdated', payload
  updateCouponsMenu: (context, payload) ->
    context.commit 'updateCouponsMenu', payload
  # Features
  updateFeatures: (context, payload) ->
    context.commit 'updateFeatures', payload
  updateFeaturesUpdated: (context, payload) ->
    context.commit 'updateFeaturesUpdated', payload
  # Recommendations
  updateRecommendations: (context, payload) ->
    context.commit 'updateRecommendations', payload
  # Myway
  updateMyway: (context, payload) ->
    context.commit 'updateMyway', payload
  updateMywayUpdated: (context, payload) ->
    context.commit 'updateMywayUpdated', payload
  # Drawers
  updatemenuDrawer: (context, payload) ->
    context.commit 'updatemenuDrawer', payload
    if payload == true
      context.dispatch 'updateorderDrawer', !payload
      context.dispatch 'updatecouponDrawer', !payload
      context.dispatch 'updatefeaturesDrawer', !payload
      context.dispatch 'updatemywayDrawer', !payload
  updateorderDrawer: (context, payload) ->
    context.commit 'updateorderDrawer', payload
    if payload == true
      context.dispatch 'updatemenuDrawer', !payload
      context.dispatch 'updatecouponDrawer', !payload
      context.dispatch 'updatefeaturesDrawer', !payload
      context.dispatch 'updatemywayDrawer', !payload
  updatecouponDrawer: (context, payload) ->
    context.commit 'updatecouponDrawer', payload
    if payload == true
      context.dispatch 'updatemenuDrawer', !payload
      context.dispatch 'updateorderDrawer', !payload
      context.dispatch 'updatefeaturesDrawer', !payload
      context.dispatch 'updatemywayDrawer', !payload
  updatefeaturesDrawer: (context, payload) ->
    context.commit 'updatefeaturesDrawer', payload
    if payload == true
      context.dispatch 'updatemenuDrawer', !payload
      context.dispatch 'updateorderDrawer', !payload
      context.dispatch 'updatecouponDrawer', !payload
      context.dispatch 'updatemywayDrawer', !payload
  updatemywayDrawer: (context, payload) ->
    context.commit 'updatemywayDrawer', payload
    if payload == true
      context.dispatch 'updatemenuDrawer', !payload
      context.dispatch 'updateorderDrawer', !payload
      context.dispatch 'updatecouponDrawer', !payload
      context.dispatch 'updatefeaturesDrawer', !payload
  # Dialog / Screen width
  updateDialogWidth: (context, payload) ->
    context.commit 'updateDialogWidth', payload
  # My Way
  updateHeaderMywayTitle: (context, payload) ->
    context.commit 'updateHeaderMywayTitle', payload
  # FAQs
  updateHeaderFaqTitle: (context, payload) ->
    context.commit 'updateHeaderFaqTitle', payload
  # Toggle
  updateToggleOpen: (context, payload) ->
    context.commit 'updateToggleOpen', payload
  updateToggleClose: (context, payload) ->
    context.commit 'updateToggleClose', payload
  # Cart
  updateHeaderOrderTitle: (context, payload) ->
    context.commit 'updateHeaderOrderTitle', payload
  # Features
  updateHeaderFeaturesTitle: (context, payload) ->
    context.commit 'updateHeaderFeaturesTitle', payload
  updateForgetLabel: (context, payload) ->
    context.commit 'updateForgetLabel', payload
  # Coupons
  updateHeaderCouponTitle: (context, payload) ->
    context.commit 'updateHeaderCouponTitle', payload
  # Checkout
  updateHeaderCheckoutTitle: (context, payload) ->
    context.commit 'updateHeaderCheckoutTitle', payload
  # Buttons
  updateButtonMenuLabel: (context, payload) ->
    context.commit 'updateButtonMenuLabel', payload
  updateButtonCheckoutLabel: (context, payload) ->
    context.commit 'updateButtonCheckoutLabel', payload
  updateOkLabel: (context, payload) ->
    context.commit 'updateOkLabel', payload
  updateMenuDrawerRestartLabel: (context, payload) ->
    context.commit 'updateMenuDrawerRestartLabel', payload
  updateFaqMessage: (context, payload) ->
    context.commit 'updateFaqMessage', payload
  updateScreenWidepx: (context, payload) ->
    context.commit 'updateScreenWidepx', payload
  # Pizza
  updatePizzaExtras: (context, payload) ->
    context.commit 'updatePizzaExtras', payload
  updateAddonExtras: (context, payload) ->
    context.commit 'updateAddonExtras', payload
  updateItemTotal: (context, payload) ->
    context.commit 'updateItemTotal', payload
  updatePizzaCount: (context, payload) ->
    context.commit 'updatePizzaCount', payload
  # Panels
  updateCategoryPanels: (context, payload) ->
    context.commit 'updateCategoryPanels', payload
  updatePizzaPanels: (context, payload) ->
    context.commit 'updatePizzaPanels', payload
  updateTypePanels: (context, payload) ->
    context.commit 'updateTypePanels', payload
  updateMenuItemGroupPanels: (context, payload) ->
    context.commit 'updateMenuItemGroupPanels', payload
  updateJumpCategory: (context, payload) ->
    context.commit 'updateJumpCategory', payload
  # Misc
  updateMenuOverflowHidden: (context, payload) ->
    context.commit 'updateMenuOverflowHidden', payload
  updateMenuItemDetails: (context, payload) ->
    context.commit 'updateMenuItemDetails', payload
  updateModifierDetails: (context, payload) ->
    context.commit 'updateModifierDetails', payload
  updateItemModselect: (context, payload) ->
    context.commit 'updateItemModselect', payload
  updateItemId: (context, payload) ->
    context.commit 'updateItemId', payload
  updatePath: (context, payload) ->
    context.commit 'updatePath', payload
  chooseCoupon: (context, payload) ->
    context.commit 'chooseCoupon', payload
  openCoupon: (context, payload) ->
    context.commit 'openCoupon', payload
  updateMap: (context, payload) ->
    context.commit 'updateMap', payload
  updateError: (context, payload) ->
    context.commit 'updateError', payload
  updateErrorTitle: (context, payload) ->
    context.commit 'updateErrorTitle', payload
  updateInformation: (context, payload) ->
    context.commit 'updateInformation', payload
  orderAddPayment: (context, payload) ->
    context.commit 'orderAddPayment', payload
  clickFlag: (context, payload) ->
    context.commit 'clickFlag', payload
  updateFlags: (context, payload) ->    
    context.commit 'updateFlags', payload
  updateRecommendationsList: (context, payload) ->    
    context.commit 'updateRecommendationsList', payload
  updateRecommendationsDialog: (context, payload) ->    
    context.commit 'updateRecommendationsDialog', payload
  updateOrderItemTotals: (context, payload) ->    
    context.commit 'updateOrderItemTotals', payload